import React, { useEffect, useMemo, useState } from 'react';

import { storageManager } from '@authFlow/utils/SessionStorageManager';

export type ThemeContextT = {
  flowTheme: string;
};

export const ThemeContext = React.createContext<ThemeContextT>({
  flowTheme: 'default',
});

ThemeContext.displayName = 'ThemeContext';

type ThemeProviderProps = {
  initialFlowTheme?: string;
  children: React.ReactNode;
};

export const ThemeProvider = ({
  initialFlowTheme,
  children,
}: ThemeProviderProps) => {
  const [flowThemeState, setFlowThemeState] = useState<string>('default');

  useEffect(() => {
    const storedTheme = storageManager.get('flowTheme');
    if (storedTheme) {
      setFlowThemeState(storedTheme);
      return;
    }

    if (initialFlowTheme) {
      setFlowThemeState(initialFlowTheme);
      storageManager.set({ flowTheme: initialFlowTheme });
      return;
    }
  }, [initialFlowTheme]);

  const contextValue = useMemo(
    () => ({ flowTheme: flowThemeState }),
    [flowThemeState],
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
